// apps/client/src/ui/kit/Tag.tsx
import { friendColors, type FriendColor } from '@whiskerton/content';
import type { CSSProperties, ReactNode } from 'react';
export function Tag(p: { color: FriendColor | 'villager'; dot?: boolean; children: ReactNode }) {
  if (p.color === 'villager') return <span className="tag tag-villager">{p.children}</span>;
  const spec = friendColors[p.color];
  const style = { '--tag': spec?.tag ?? '#C84B30', '--tag-text': spec?.textOnTag ?? '#FFFFFF', '--tag-ink': spec?.textOnTag ?? '#FFFFFF' } as CSSProperties;
  return <span className="tag" style={style}>{p.dot && <i className="tag-dot" />}{p.children}</span>;
}
